import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "excursion_item-2" }
const _hoisted_2 = { class: "excursion_item-2_back" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "desc_wrap" }
const _hoisted_5 = { class: "i_img_wrap-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "i_desc-2" }
const _hoisted_8 = { class: "text_wrap" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "i_name-2" }
const _hoisted_11 = {
  class: "pointer",
  style: {"overflow-wrap":"break-word"}
}
const _hoisted_12 = { class: "tegs_text_wrap" }
const _hoisted_13 = { style: {"overflow-wrap":"break-word"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  class: "show_all",
  style: {"display":"none"}
}, "Показать все", -1)
const _hoisted_15 = { class: "tags layout-scrollbar" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "scroll_wrap" }, [
  /*#__PURE__*/_createElementVNode("button", {
    "data-factor": "-1",
    class: "scroll left"
  }, "<"),
  /*#__PURE__*/_createElementVNode("button", {
    "data-factor": "1",
    class: "scroll right"
  }, ">")
], -1)
const _hoisted_17 = { class: "square_price_wrap" }
const _hoisted_18 = { class: "square_price" }
const _hoisted_19 = { class: "rait_abs" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "star_rate", -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "color_block" }
const _hoisted_24 = { class: "the_price" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.excursion.image
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: _ctx.excursion.image
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.excursion.name), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.excursion.description), 1),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFeatures, (feature, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, " #" + _toDisplayString(feature), 1))
                }), 128))
              ]),
              _hoisted_16
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(_toDisplayString(_ctx.excursion.rating) + " ", 1),
                _hoisted_20
              ]),
              _createElementVNode("a", {
                target: "_blank",
                href: _ctx.excursion.source_link,
                class: "res_url"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.excursion.format), 1),
                  _createTextVNode(" на " + _toDisplayString(_ctx.excursion.duration_str), 1),
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, [
                    _createTextVNode(" за "),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.excursion.price) + " руб", 1),
                    _hoisted_25,
                    _createTextVNode(" на " + _toDisplayString(_ctx.excursion.marketplace), 1)
                  ])
                ])
              ], 8, _hoisted_21)
            ])
          ])
        ])
      ])
    ])
  ]))
}